import { io } from "socket.io-client";
let socket = undefined;
const localIP = "localhost";
const networkIP = "chat.holy-code.de";
const port = 433;
const networkConnection = true;
export function initSocket(spielerHash) {
  //console.log('init socket')
  const url = networkConnection
    ? "https://" + networkIP
    : "http://" + localIP + ":" + port;

  socket = io(url, {
    auth: { hash: spielerHash },
  });
}

export function status() {
  return !!socket;
}

export function sendEvent(event) {
  //console.log("Sende zu Server", event);

  if (socket) {
    socket.emit(event.type, event.data);
  }
}

export function initSocketEvents(that) {
  if (socket) {
    socket.onAny((eventName) => {
      //console.log('Empfange ', eventName)
    });
    socket.on("debug", (data) => {
      console.log("debug", data);
    });
    socket.on("RoomListe", (data) => {
      //console.log(data.roomListe)
      that.setRoomListe(data);
    });
    socket.on("Update", (data) => {
      //console.log(data.room)
      that.update(data.room);
    });
    socket.on("loadRooms", (data) => {
      //console.log(data.room)
      that.loadRooms();
    });
    socket.on("goToRoom", (data) => {
      //console.log('gotoroom', data)
      that.goToRoom(data.room);
    });
    socket.on("ScrollDown", (data) => {
      that.scrollToEnd();
    });
    socket.on("JoinRoomSuccess", (data) => {
      //console.log('Suc', data)
      that.goToRoom(data.roomName);
    });
    socket.on("LeaveRoom", (data) => {
      that.leaveRoom(data);
    });
  }
}
